<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <slot/>
    </form>
  </ValidationObserver>
</template>

<script>
import FormMixin from '@/mixins/FormMixin'

export default {
  name: 'DForm',
  props: {
    children: {},
  },
  mixins: [FormMixin],
  methods: {
    submit() {
      this.$emit('submit')
    },
  },
}
</script>
